import Alert from 'react-s-alert';
import { DSOS_ACTIONS, REFERRAL_ACTIONS, SHOW_MESSAGE } from '../actions/actionTypes';
import { SessionEndedError } from '../errors/SessionEndedError';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

const BLOCKED_ERRORS = [DSOS_ACTIONS.REMOVE_REGION_FROM_DSO_FAILURE];

// The empty-error-body fallback below is scoped to only these actions —
// referral-service (and every x/httprunner service) answers 401/403 with an
// empty body, but every other action in the app still goes through the
// monolith, whose errors already carry a message. Applying it app-wide would
// show a generic "Request failed (404)" on unrelated pages.
const REFERRAL_FAILURE_ACTIONS = [
  REFERRAL_ACTIONS.GET_REFERRAL_FAILURE,
  REFERRAL_ACTIONS.CANCEL_REFERRAL_FAILURE,
];

export default (state = { message: null }, action) => {
  const { type } = action;

  if (BLOCKED_ERRORS.includes(type)) {
    return state;
  }

  const matches = /(.*)_(FAILURE)/.exec(type);
  if (matches) {
    // The session is ending and the sign-in screen is already showing; this error carries no message.
    if (action.payload instanceof SessionEndedError) return state;

    const authServiceErrors = [action.payload?.response?.data?.error].filter(Boolean);
    const errors = action.payload.response?.data?.errors || authServiceErrors;
    const baseMessage = errors.map((err) => err.message || err).join('\n');
    // referral-service (and every x/httprunner service) answers 401/403 with an
    // empty body and a network/CORS failure has no response at all; without a
    // fallback the toast renders blank. Scoped to the referral actions only.
    const message =
      baseMessage ||
      (REFERRAL_FAILURE_ACTIONS.includes(type) &&
        (action.payload?.response?.status
          ? `Request failed (${action.payload.response.status})`
          : action.payload?.message || 'Request failed')) ||
      '';
    Alert.error(message, {
      position: 'bottom-right',
      effect: 'slide',
      beep: false,
      timeout: 5000,
      offset: 100,
    });
    return state;
  }

  switch (action.type) {
    case SHOW_MESSAGE:
      const { message } = action.payload;
      Alert.success(message, {
        position: 'bottom-right',
        effect: 'slide',
        beep: false,
        timeout: 5000,
        offset: 100,
      });
      break;
    default:
      break;
  }

  return state;
};
